export enum DayPeriodEnum {
  AM = 'AM',
  PM = 'PM',
}
